module.exports = __webpack_public_path__ + "files/f980ca72a0d0876d0451f9e8d7b25c02.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Regular.woff
// module id = 1420
// module chunks = 59